<template>
  <div class="index">
    <div class="index-con">
      <!-- <img class="index-img" src="@/assets/images/new-018.jpg" alt="" /> -->
      <div class="router">
        <span>IRADSTM</span> <b>→</b> <span>关于IRADSTM</span> <b>→</b>
        <span>IRADSTM委员会</span>
      </div>

      <div class="box">
        <div class="left">
          <div class="box-title">IRADSTM首届理事会</div>
          <div class="people-content">

            <div class="people-lists">
              <div class="people-list" @click="lookFn(item, index)" v-for="(item, index) in speakList1" :key="index"
                style="width: 197px;margin: 23px 11px;">
                <div class="people-pic">
                  <img :src="'http://music.chinaman.cn/mybigdatas/iradstm/images/' +
                    item.image_url
                    " alt="" />
                </div>
                <div class="peoples-title">
                  <b>{{ item.name }}</b>
                </div>
                <div class="people-text">{{ item.position }}</div>
                <div class="country">({{ item.country }})</div>
              </div>
            </div>
            <div class="people-lists col-5">
              <div class="people-list" @click="lookFn(item, index)" v-for="(item, index) in speakList2" :key="index">
                <div class="people-pic">
                  <img :src="'http://music.chinaman.cn/mybigdatas/iradstm/images/' +
                    item.image_url
                    " alt="" />
                </div>
                <div class="peoples-title">
                  <b>{{ item.name }}</b>
                </div>
                <div class="people-text">{{ item.position }}</div>
                <div class="country">({{ item.country }})</div>
              </div>
            </div>
          </div>

          <div class="box-title">IRADSTM首届监事会</div>
          <div class="people-content">
            <div class="people-lists">
              <div class="people-list" @click="lookFn(item, index)" v-for="(item, index) in speakList3" :key="index"
                style="width: 197px;margin: 23px 11px;">
                <div class="people-pic">
                  <img :src="'http://music.chinaman.cn/mybigdatas/iradstm/images/' +
                    item.image_url
                    " alt="" />
                </div>
                <div class="peoples-title">
                  <b>{{ item.name }}</b>
                </div>
                <div class="people-text">{{ item.position }}</div>
                <div class="country">({{ item.country }})</div>
              </div>
            </div>
          </div>

          <div class="box-title">IRADSTM首届秘书处</div>
          <div class="people-content">
            <div class="people-lists" style="width: 100%;">
              <div style="width: 20%;margin: 0 0 30px;" class="people-list" @click="lookFn(item, index)"
                v-for="(item, index) in speakList4" :key="index">
                <div class="people-pic">
                  <img :src="'http://music.chinaman.cn/mybigdatas/iradstm/images/' +
                    item.image_url
                    " alt="" />
                </div>
                <div class="peoples-title">
                  <b>{{ item.name }}</b>
                </div>
                <div class="people-text">{{ item.position }}</div>
                <div class="country">({{ item.country }})</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      jbList: [],
      speakList1: [
        {
          image_url: "Zhang.jpg",
          name: "张慜",
          position: "主席",
          country: "中国",
        },
        {
          image_url: "Mujumdar.jpg",
          name: "Arun S. Mujumdar",
          position: "荣誉主席",
          country: "加拿大",
        },
      ],
      speakList2: [
        {
          image_url: "Bhandari.jpg",
          name: "Bhesh Bhandari",
          position: "副主席",
          country: '澳大利亚'
        },
        {
          image_url: "Dongxing.jpg",
          name: "郁东兴",
          position: "副主席",
          country: '中国'
        },
        {
          image_url: "Tsotsas.jpg",
          name: "Evangelos Tsotsas",
          position: "副主席",
          country: '德国'
        },
        {
          image_url: "Zbicinski.jpg",
          name: "Ireneusz Zbicinski",
          position: "副主席",
          country: '波兰'
        },
        {
          image_url: "Yoshinori.jpg",
          name: "Itaya Yoshinori",
          position: "副主席",
          country: '日本'
        },

        {
          image_url: "Miriam.jpg",
          name: "Miriam Dupas Hubinger",
          position: "副主席",
          country: '巴西'
        },
        {
          image_url: "Devahastin.jpg",
          name: "Sakamon Devahastin",
          position: "副主席",
          country: '泰国'
        },
        {
          image_url: "Pang.jpg",
          name: "Shusheng Pang",
          position: "副主席",
          country: '新西兰'
        },

        {
          image_url: "Umezuruike.jpg",
          name: "Umezuruike Linus Opara",
          position: "副主席",
          country: '南非'
        },

        {
          image_url: "Raghavan.jpg",
          name: "Vijaya G.S. Raghavan",
          position: "副主席",
          country: '加拿大'
        },
      ],
      speakList3: [
        {
          image_url: "Shaojin.jpg",
          name: "王绍金",
          position: "监事长",
          country: '美国'
        },
        {
          image_url: "Law.jpg",
          name: "Chung Lim Law",
          position: "副监事长",
          country: '马来西亚'
        },
        {
          image_url: "Chunquan.jpg",
          name: "刘春泉",
          position: "副监事长",
          country: '中国'
        },
      ],
      speakList4: [
        {
          image_url: "Hong-Wei.jpg",
          name: "肖红伟",
          position: "秘书长",
          country: '中国'
        },
        {
          image_url: "Adhikari.jpg",
          name: "Benu Adhikari",
          position: "副秘书长",
          country: '澳大利亚'
        },
        {
          image_url: "Duan.jpg",
          name: "段续",
          position: "副秘书长",
          country: '中国'
        },
        {
          image_url: "Zhonghua.jpg",
          name: "吴中华",
          position: "副秘书长",
          country: '中国'
        },
        {
          image_url: "Min.jpg",
          name: "李敏",
          position: "常设秘书",
          country: '中国'
        },
      ],
    };
  },
  mounted() {
    // this.getjbList();
  },
  methods: {
    lookFn(item, index) {
      console.log(item, index);
      // this.$router.push({
      //   path: "/committeesDetail?id=" + item.news_id,
      // });
    },
    getjbList() {
      this.$http
        .jb_list({
          page: this.page,
          pagesize: 20,
          type_id: 832,
        })
        .then((res) => {
          this.jbList = res.data;
        });
    },
  },
};
</script>

<style lang="less" scoped>
.people-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
}

.people-lists {
  margin: 0 auto;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  flex-wrap: wrap;
}

.col-5 {
  .people-list {
    width: calc(20% - 23px);
    margin: 23px 11px;
  }
}

.people-list {
  margin: 23px;
  display: flex;
  flex-direction: column;
  text-align: center;
}

.people-pic {
  width: 110px;
  height: 150px;
  border: 3px solid #ccc;
  background-color: #ccc;
  margin: 0 auto;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.country {
  font-size: 15px;
  color: rgb(93, 86, 86);
}

.people-pic img {
  height: 100%;
  width: 100%;
  object-fit: cover;
}

.index-con {
  width: 1200px;
  margin: 0 auto;
  padding-bottom: 50px;

  .text {
    font-size: 16px;
    line-height: 2;
  }

  .box-title {
    position: relative;
    padding-bottom: 10px;
    color: #5b965a;
    font-family: Canaro, Arial, sans-serif;
    font-size: 30px;
    line-height: 1.9;
    font-weight: 700;
    margin-bottom: 30px;

    &::before {
      content: "";
      position: absolute;
      bottom: 0;
      left: 0;
      width: 600px;
      max-width: 100%;
      height: 6px;
      background-color: #5b965a;
    }
  }

  .box {
    display: flex;
    padding-right: 100px;
    box-sizing: border-box;
    align-items: center;

    .left {
      flex: 1;
    }

    .right {
      padding: 40px 0;
      flex-shrink: 0;
      margin-left: 60px;
      width: 230px;
      border-top: 10px solid #f9b033;
      border-bottom: 10px solid #5b965a;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        width: 70%;
      }
    }
  }

  .router {
    display: flex;
    margin: 23px 0 31px;
    align-items: center;

    span {
      color: rgba(31, 31, 31, 0.5);
      font-family: Canaro, Arial, sans-serif;
      font-size: 11px;
      line-height: 1.8;
      font-weight: 400;
      white-space: nowrap;
      cursor: pointer;
    }

    b {
      color: #f9b033;
      font-weight: 400;
      margin: 0 10px;
    }

    span:nth-last-of-type(1) {
      color: #333;
    }
  }

  .index-img {
    width: 100%;
    height: auto;
  }
}

@media screen and (max-width: 768px) {
  .index-con {
    width: 100%;
    padding: 10px;
    box-sizing: border-box;

    .box {
      padding-right: 0;
      display: block;

    }

    .box-title {
      font-size: 18px;
    }

    .people-content{
      display: block;
    }

    .people-list {
      width: calc(50% - 15px)!important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/committees.vue